import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const Result = () => {
    const { state } = useLocation();
    // const [total, setTotal] = useState(0);

    // useEffect(() => {
    //     let sumCompulsory = 0;
    //     let sumCombination = 0;
    //     state.result.map((item) => {
    //         if (item.subject === "Văn") {
    //             sumCompulsory += Number(item.score);
    //         }
    //         if (item.subject === "Toán") {
    //             sumCompulsory += Number(item.score);
    //         }
    //         if (item.subject === "Anh") {
    //             sumCompulsory += Number(item.score);
    //         }
    //         else {
    //             sumCombination += Number(item.score);
    //         }
    //     });
    //     setTotal((((sumCompulsory + (sumCombination / 3) + state.pointencourage) / 4) * 7 + (state.point12 * 3)) / 10 + state.pointprioritize);
    // }, []);

    return (
        <div className="container">
            <h2 className="mb-5">
                Kết Quả Tra Cứu Điểm Thi THPT năm 2024
            </h2>

            <div className="resultSearch__left">
                <div className="resultSearch__left-sbd">
                    <p>Số báo danh</p>
                    <p className="font-bold">{state?.id}</p>
                </div>
                <div className="resultSearch__left-info">
                    <p className="edu-institution">Sở GD&amp;ĐT Thành Phố Hồ Chí Minh</p>

                    <div className="controll__box share-link">
                        <a className="newFeature__iconLink" title="Chia sẻ bài viết lên facebook" titleshare="Chi tiết điểm thi tốt nghiệp THPT" type="facebook" href="javascript:;">
                            <span className="img img-facebook"></span>
                        </a>
                        <a className="newFeature__iconLink" title="Chia sẻ bài viết lên twitter" titleshare="Chi tiết điểm thi tốt nghiệp THPT" type="twitter" href="javascript:;">
                            <span className="img img-twitter"></span>
                        </a>
                        <a className="newFeature__iconLink" title="Chia sẻ bài viết lên email" titleshare="Chi tiết điểm thi tốt nghiệp THPT" type="email" href="javascript:;">
                            <span className="img img-email"></span>
                        </a>
                        <a className="newFeature__iconLink tooltip" href="#share" type="copy" titleshare="Chi tiết điểm thi tốt nghiệp THPT" title="Sao chép liên kết">
                            <span className="tooltiptext" id="myTooltip">Sao chép liên kết</span>
                            <span className="img img-share"></span>
                        </a>
                    </div>
                </div>
            </div>

            <div className="resultSearch__right">
                <table>
                    <thead>
                        <tr>
                            <th>Môn</th>
                            <th>Điểm</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            state && state?.result && state?.result.length > 0 &&
                            state?.result.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{item?.subject}</td>
                                        <td>{item?.score}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>

            {/* <br />
            <div className="d-flex flex-column justify-content-center align-items-center">
                <span style={{ color: "red", fontSize: "larger", fontWeight: "bold" }}>Điểm xét tốt nghiệp THPT của bạn là: {total}</span>
                <br />
                <br />
                <p>Nếu trang web bị quá tải Phụ Huynh và các bạn thí sinh vui lòng tra cứu điểm tại đây: <a href="https://laodong.vn/giao-duc/tra-cuu-diem-thi-tot-nghiep-thpt-nam-2023-cua-63-tinh-thanh-tren-ca-nuoc-1217388.ldo">Link tại đây</a></p>

            </div>
            <br /> */}
            <br />
            <div className="d-flex flex-row justify-content-around">
                <a href="https://zalo.me/g/xxpwxr794"><img src={require("../assets/images/2.jpg")} alt="zaloGroup" width="300" height="200" /></a>
                <a href="https://www.viendong.edu.vn/huong-dan-lam-thu-tuc-nhap-hoc-danh-cho-thi-sinh-2024.html"><img src={require("../assets/images/1.jpg")} alt="Cao đẳng Viễn Đông" width="300" height="200" /></a>
            </div>
        </div>
    )
}

export default Result;